export enum SubSystem {
  ADMINISTRATION = 'administration',
  ERP_WMS = 'erp_wms',
  ASSETS = 'assets',
  CONTRACTS = 'contracts',
  ERP_SMALL_INVENTORY = 'erp_small_inventory',
  PROCUREMENT = 'procurement',
}
